import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { OptionMenuContainer, OptionMenuItem } from '../../ui/OptionMenu';
import { useTaskManager } from '../../../hooks/userTaskManager';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

export function OptionMenu() {
    const { currentEmpresaId } = useTaskManager();

    const [openMenu, setOpenMenu] = useState(false);

    const buttonRef = useRef<HTMLButtonElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setOpenMenu(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                onClick={() => setOpenMenu(!openMenu)}>
                <MoreVertRoundedIcon sx={{
                    ":hover": {
                        backgroundColor: "#e2e8f0", 
                    },
                    borderRadius: 1,
                }}/>
            </button>

            {openMenu && (
            <div
                ref={modalRef}
                className="absolute"
                style={{ insetInlineEnd: 0 }}>
                <OptionMenuContainer>
                    <div>
                        <Link
                            to="/calendario"
                            state={{ empresaId: currentEmpresaId }}
                            className="hover:text-black">
                            <OptionMenuItem>
                                <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                                <p className="text-sm font-semibold text-center">Mostrar tareas en calendario</p>
                            </OptionMenuItem>
                        </Link>
                    </div>
                </OptionMenuContainer>
            </div>
            )}

        </div>
    );
}
